var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_c('v-overlay',{attrs:{"value":_vm.showLoading,"z-index":"99990"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_c('message-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }